require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./auditeurs-2-6-8.json") })
        }
      }, "path---auditeurs-2-6-8");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---auditeurs-2-6-8!./.cache/json/auditeurs-2-6-8.json
// module id = 341
// module chunks = 231608221292675